<script lang="js">
import { Line, mixins } from 'vue-chartjs'
import chartjsPluginStyle from 'chartjs-plugin-style';
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  },
  watch: {
    options: function() {
      this.renderChart(this.chartData, this.options);
    }
  }
}
</script>

<style scoped lang="scss">

</style>
